import { ConfigOption } from '@ngx-formly/core';
import { FormlyTimelineWidgetComponent } from './formly-timeline-widget/formly-timeline-widget.component';

export const TIMELINE_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-timeline', component: FormlyTimelineWidgetComponent },
]
